import React from 'react';

function Services() {
  return (
    <section className="tc-services-style1">
      <div className="content section-padding section-padding-x">
        <div className="container">
          <div className="title mb-80 text-center">
            <p className="color-666 text-uppercase wow"> our services </p>
          </div>
          <div className="services">
            <div className="row">
              <div className="col-lg-3">
                <a
                  href="/single_project"
                  className="service-card wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <div className="icon">
                    <i className="la la-building"></i>
                  </div>
                  <h5 className="fsz-24 mb-20"> GLASS FAÇADE</h5>
                  <div className="img">
                    <img
                      src="/innerpages/assets/img/services/ser1.webp"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div >
                  <div className="text  mt-50">
                    <ul className="styled-points ">
                        <li>Curtain Wall</li>
                        <li>Stick Glazing </li>
                        <li>Window Wall System</li>
                        <li>Slim Profile System</li>
                      </ul>
                  </div>
                  </div>
                  <span className="arrow">
                    <i className="ti-arrow-top-right"></i>
                  </span>
                </a>
              </div>
              <div className="col-lg-3">
                <a
                  href="/single_project3"
                  className="service-card mt-150 wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <div className="icon">
                    <i className="la la-city"></i>
                  </div>
                  <h5 className="fsz-24 mb-20">
                    {' '}
                    FACADE SOLUTIONS{' '}
                  </h5>
                  <div className="img">
                    <img
                      src="\home2\assets\img\services\ser2.webp"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text  mt-50">
                     <ul className="styled-points ">
                        <li>HPL </li>
                        <li>Zinc,Copper Composite</li>
                        <li>ACP</li>
                        <li>Copper Composite</li>
                        <li>Louver</li>
                        <li>Channel Partner For Aludecore</li>
                      </ul>
                    </div>
                  <span className="arrow">
                    <i className="ti-arrow-top-right"></i>
                  </span>
                </a>
              </div>
              <div className="col-lg-3">
                <a
                  href="/single_project4"
                  className="service-card wow fadeInUp"
                  data-wow-delay="0.6s"
                >
                  <div className="icon">
                    <i className="la la-door-open"></i>
                  </div>
                  <h5 className="fsz-24 mb-20"> ALUMINIUM DOORS &  SOLUTIONS </h5>
                  <div className="img">
                    <img
                      src="/innerpages/assets/img/services/ser3.webp"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text color-666 mt-50">
                    <ul className="styled-points ">
                        <li>Sliding & Casement Systems</li>
                        <li>Thermal Break Profiles</li>
                        <li>Acoustic & Weather Sealing</li>
                        <li>Custom Design & Fabrication</li>
                      </ul>
                 </div>
                  <span className="arrow">
                    <i className="ti-arrow-top-right"></i>
                  </span>
                </a>
              </div>
              {/* <div className="col-lg-3">
                <a
                  href="#"
                  className="service-card mt-150 wow fadeInUp"
                  data-wow-delay="0.8s"
                >
                  <div className="icon">
                    <i className="la la-grip-lines"></i>
                  </div>
                  <h5 className="fsz-24 mb-20">
                   RAILINGS, TACTILE & BALUSTRADE
                  </h5>
                  <div className="img">
                    <img
                      src="/innerpages/assets/img/services/rail.jpg"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text color-666 mt-50">
                    <ul className="styled-points ">
                        <li>Glass & SS Railings</li>
                        <li>Aluminium Balustrades</li>
                        <li>Handrails with Tactile Indicators</li>
                        
                      </ul>
                    </div>
                  <span className="arrow">
                    <i className="ti-arrow-top-right"></i>
                  </span>
                </a>
              </div> */}
             {/* <div className="col-lg-3">
                <a
                  href="#"
                  className="service-card wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <div className="icon">
                    <i className="la la-sliders-h"></i>
                  </div>
                  <h5 className="fsz-24 mb-20">SLIDING & FOLDING PARTITIONS</h5>
                  <div className="img">
                    <img
                      src="/innerpages/assets/img/services/slide.jpg"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text color-666 mt-50">
                    <ul className="styled-points ">
                        <li>Glass Sliding Systems</li>
                        <li>Acoustic Folding Partitions</li>
                        <li>Office Partition Systems</li>
                        
                      </ul>
                  </div>
                  <span className="arrow">
                    <i className="ti-arrow-top-right"></i>
                  </span>
                </a>
              </div> */}
              {/* <div className="col-lg-3">
                <a
                  href="#"
                  className="service-card mt-150 wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <div className="icon">
                    <i className="la la-ruler-combined"></i>
                  </div>
                  <h5 className="fsz-24 mb-20">
                    {' '}
                    ALUMINIUM PROFILES FOR PARTITIONS{' '}
                  </h5>
                  <div className="img">
                    <img
                      src="/innerpages/assets/img/services/alumn.jpg"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text color-666 mt-50">
                    <ul className="styled-points ">
                        <li>Slim Profiles</li>
                        <li>Glazed Systems</li>
                        <li>Custom Finishes</li>
                      </ul>
                      </div>
                  <span className="arrow">
                    <i className="ti-arrow-top-right"></i>
                  </span>
                </a>
              </div> */}
              {/* <div className="col-lg-3">
                <a
                  href="#"
                  className="service-card wow fadeInUp"
                  data-wow-delay="0.6s"
                >
                  <div className="icon">
                    <i className="la la-paint-roller"></i>
                  </div>
                  <h5 className="fsz-24 mb-20"> INTERIOR FIT-OUT SOLUTIONS </h5>
                  <div className="img">
                    <img
                      src="/innerpages/assets/img/services/ser3.jpg"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text color-666 mt-50">
                     <ul className="styled-points ">
                        <li>Custom Furniture & Fixtures</li>
                        <li>Electrical & Lighting</li>
                        <li>Flooring & Ceilings</li>
                        <li>Partitions & Wall Finishes</li>
                        <li>HVAC & Plumbing</li>
                      </ul>
                  </div>
                  <span className="arrow">
                    <i className="ti-arrow-top-right"></i>
                  </span>
                </a>
              </div> */}
              <div className="col-lg-3">
                <a
                  href="single_project6"
                  className="service-card mt-150 wow fadeInUp"
                  data-wow-delay="0.8s"
                >
                  <div className="icon">
                    <i className="la la-volume-up"></i>
                  </div>
                  <h5 className="fsz-24 mb-20">
                    ACOUSTIC SOLUTIONS
                  </h5>
                  <div className="img">
                    <img
                      src="\home2\assets\img\services\acoustic.webp"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text color-666 mt-50">
                    <ul className="styled-points mt-4">
                        <li>Movable wall</li>
                        <li>Halspan Core</li>
                      </ul>
                  </div>
                  <span className="arrow">
                    <i className="ti-arrow-top-right"></i>
                  </span>
                </a>
              </div>
              <div className="col-lg-3">
                <a
                  href="single_project5"
                  className="service-card wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <div className="icon">
                    <i className="la la-tools"></i>
                  </div>
                  <h5 className="fsz-24 mb-20"> ARCHITECTURAL HARDWARE SOLUTIONS </h5>
                  <div className="img">
                    <img
                      src="\home2\assets\img\services\hardware.webp"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text color-666 mt-50">
                    <ul className="styled-points mt-4">
                        <li>Geze Hardware</li>
                        
                      </ul>
                  </div>
                  <span className="arrow">
                    <i className="ti-arrow-top-right"></i>
                  </span>
                </a>
              </div>
              <div className="col-lg-3">
                <a
                  href="/single_project3"
                  className="service-card mt-150 wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <div className="icon">
                    <i className="la la-city"></i>
                  </div>
                  <h5 className="fsz-24 mb-20">
                    {' '}
                    ALUMINIUM PROFILES FOR PARTITION{' '}
                  </h5>
                  <div className="img">
                    <img
                      src="\home2\assets\img\services\partition.png"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text  mt-50">
                     <ul className="styled-points ">
                        <li>Lightweight yet structurally strong framework</li>
                        <li>Customizable designs for offices & interiors</li>
                        <li>Corrosion-resistant and low maintenance</li>
                        <li>Compatible with glass, gypsum & composite panels</li>
                      </ul>
                    </div>
                  <span className="arrow">
                    <i className="ti-arrow-top-right"></i>
                  </span>
                </a>
              </div>
  
            </div>
          </div>
          <div className="text-center">
            <a
              href="https://wa.me/+918754505413"
              className="butn rounded-pill mt-80 hover-bg-black bg-orange1 text-white"
            >
              <span>
                Get A Free Quote Now
                <i className="small ms-1 ti-arrow-top-right"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
      <div className="ser-img">
        <img src="/innerpages/assets/img/services/service.jpg" alt="" />
      </div>
    </section>
  );
}

export default Services;
